import React from "react";
import { FaCheck } from "react-icons/fa";

import { IconTag } from "./IconTag";

type PassedTagProps = {
  text?: string;
};

/**
 * An IconTag wrapper to mark something as "passed".
 */
function IconTagPassed({ text = "Passed", ...delegated }: PassedTagProps) {
  return (
    <IconTag icon={FaCheck} text={text} colorScheme="success" {...delegated} />
  );
}

export { IconTagPassed };
